export type PermitApplicationDocumentRole = "attachment" | "application" | "plan" | "evidence";

export const PERMIT_APPLICATION_DOCUMENT_ROLE_LABELS: Record<
  PermitApplicationDocumentRole,
  string
> = {
  attachment: "Attachment",
  application: "Application",
  plan: "Plan",
  evidence: "Evidence",
};

export type PermitApplicationDocumentLink = {
  id: number;
  permit_application_id: number;
  document_id: number;
  name: string;
  file_path: string;
  label: string | null;
  role: string;
  linked_by_user_id: number;
  linked_by_name: string;
  created_at: string;
};

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

export async function listPermitApplicationDocuments(
  municipalityId: number,
  applicationId: number,
): Promise<PermitApplicationDocumentLink[]> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/documents`,
    { credentials: "include", headers: { Accept: "application/json" } },
  );
  if (!response.ok) throw new Error("Failed to load documents");
  return response.json();
}

export async function linkPermitApplicationDocument(
  municipalityId: number,
  applicationId: number,
  documentId: number,
  options?: { label?: string; role?: PermitApplicationDocumentRole },
): Promise<PermitApplicationDocumentLink> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/documents`,
    {
      method: "POST",
      credentials: "include",
      headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
      body: JSON.stringify({
        permit_application_document: {
          document_id: documentId,
          label: options?.label ?? null,
          role: options?.role ?? "attachment",
        },
      }),
    },
  );
  if (!response.ok) throw new Error("Failed to link document");
  return response.json();
}

export async function unlinkPermitApplicationDocument(
  municipalityId: number,
  applicationId: number,
  linkId: number,
): Promise<void> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/documents/${linkId}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: { "X-CSRF-Token": csrfToken() },
    },
  );
  if (!response.ok) throw new Error("Failed to unlink document");
}
